import DashboardItem from './DashboardItem';

export default DashboardItem;
export * from './DashboardItem';
